var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"main-container"},[_c('div',{attrs:{"id":"redirect-info"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }